/**
 * @function isUserOnOrPastSafariTwelve
 *
 * Checks if the browser is Safari later than version 12
 *
 * @return {void}
 *
 * @example
 *
 *         isUserOnOrPastSafariTwelve(userBrowser)
 */
export const isUserOnOrPastSafariTwelve = (userBrowser: {
  name: string;
  version: string;
}) => {
  if (
    userBrowser.name === "Safari" &&
    Number(userBrowser.version.split(".")[0]) >= 12
  ) {
    return true;
  } else {
    return false;
  }
};
try {
    // @ts-ignore
    isUserOnOrPastSafariTwelve.displayName = "isUserOnOrPastSafariTwelve";
    // @ts-ignore
    isUserOnOrPastSafariTwelve.__docgenInfo = { "description": "", "displayName": "isUserOnOrPastSafariTwelve", "props": { "name": { "defaultValue": null, "description": "", "name": "name", "required": true, "type": { "name": "string" } }, "version": { "defaultValue": null, "description": "", "name": "version", "required": true, "type": { "name": "string" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/containers/GoodData/utilities/isUserOnOrPastSafariTwelve.ts#isUserOnOrPastSafariTwelve"] = { docgenInfo: isUserOnOrPastSafariTwelve.__docgenInfo, name: "isUserOnOrPastSafariTwelve", path: "src/shared/containers/GoodData/utilities/isUserOnOrPastSafariTwelve.ts#isUserOnOrPastSafariTwelve" };
}
catch (__react_docgen_typescript_loader_error) { }